import React from "react";

export default function ErrorPage({ message = "Ocorreu um erro.", onBack }) {
  return (
    <div className="text-center mt-20 px-4 max-w-xl mx-auto">
      <h1 className="text-3xl font-bold text-red-600 mb-4">Ops!</h1>
      <p className="mb-6 text-lg">{message}</p>
      {onBack && (
        <button
          onClick={onBack}
          className="button button-azul px-6 py-2 rounded"
          type="button"
        >
          Voltar
        </button>
      )}
    </div>
  );
}
